import "./App.css";
import React from "react";
import { Route, Routes } from "react-router-dom";
import SideBar from "./components/sideBar";
import Subscriptions from "./components/subscriptions";
import Login from "./components/login";
import NavBar from "./components/navBar";
import ContactUs from "./components/contact";
import Bending from "./components/bending";
import Terms from "./components/terms";

function App() {
  return (
    <React.Fragment>
      <div className="container-fluid main-color">
        <div className="row flex-nowrap">
          <SideBar />
          <div className="col px-0 page-container rounded-start-5 vstack justify-content-between">
            <NavBar />
            <Routes>
              <Route path="investmentplans" element={<Subscriptions />} />
              <Route path="contactus" element={<ContactUs />} />
              <Route path="bending" element={<Bending />} />
              <Route path="terms" element={<Terms />} />
            </Routes>
          </div>
        </div>
      </div>
      <Login />
    </React.Fragment>
  );
}

export default App;
